import {clientapi} from '@/interceptors/clientapi'
import Cookie from 'js-cookie'

export default {
  getUser() {
    let token = Cookie.get('access_token')

    if (!token) {
      return null
    }

    return this.getUserFromToken(token)
  },
  async getDirectoryService(){
    let result = await clientapi.get('/services/directory')

    if (result.status == 200){
      return result.data
    }

    return { Free: 0, Status: 'NOT_ACTIVE', Featured: 0, FeaturedPremium: 0 }
  },

  async getPropertyService(){
    let result = await clientapi.get('/services/property')

    if (result.status == 200){
      return result.data
    }

    return { Status: 'NOT_ACTIVE', PropertyLimit: 0 }
  },
  async getFeaturedService(){
    let result = await clientapi.get('/services/featured')

    if (result.status == 200){
      return result.data
    }

    return { Featured: 0, Premium: 0 }
  },
  async getFeaturedService(){
    let result = await clientapi.get('/services/featured')

    if (result.status == 200){
      return result.data
    }

    return { MaxFeaturedStandard: 0, MaxFeaturedPremium: 0 }
  },
  // https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
  parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload)
  },

  getUserFromToken(accessToken) {
    return this.parseJwt(accessToken)["user"]
  },

  getAdmin() {
    let accessToken = Cookie.get('admin_access_token')

    if (!accessToken) {
      return null
    }

    return this.parseJwt(accessToken)["user"]
  },

  onBeforeOpenSwal() {
    document.activeElement.blur();
    setTimeout(function (){
      document.activeElement.blur();
    },1000)

  },

  checkIfEmail(text){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text);
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/functions.js
// module id = null
// module chunks = 